module.exports = __webpack_public_path__ + "favicon/apple-touch-icon.png";